import { css } from '@emotion/react';
import { PracticeAnalyticsTypes } from '@frontend/api-analytics';
import { AdaptoActions } from '@frontend/adapto-actions';
import { Actions } from '@frontend/contact-actions';
import { FirstWordBoldText, WidgetizedDashboardTrackingIds } from '@frontend/grid-dashboard';
import { useTranslation } from '@frontend/i18n';
import { formatters } from '@frontend/shared';
import { theme } from '@frontend/theme';
import { Avatar, Text } from '@frontend/design-system';

interface Props {
  item: PracticeAnalyticsTypes.PatientInfo;
}

const opportunityListTrackingId = WidgetizedDashboardTrackingIds.widgetSpecificTrackingId('opportunity-list-action');

export const OpportunityItem = ({ item }: Props) => {
  const { t } = useTranslation('analytics');

  const personName = `${item.FirstName} ${item.LastName}`.trim();
  const personNumber = item.MobilePhone || item.HomePhone || item.WorkPhone;

  return (
    <li css={itemStyle}>
      <div>
        <Avatar css={{ color: theme.colors.success20 }} name={personName} size='small' />
        <FirstWordBoldText size='medium'>{personName}</FirstWordBoldText>
      </div>
      <Text>{item.productionAmount ? formatters.currency(item.productionAmount) : '-'}</Text>
      <AdaptoActions variant='action-buttons' iconColor='inherit'>
        <Actions.Call
          label={t('Call {{name}}', {
            name: personName || personNumber,
          })}
          trackingIdSuffix={opportunityListTrackingId('call')}
          context={{
            personId: item.id,
            phoneNumber: item.MobilePhone,
          }}
        />
        <Actions.Message
          context={{
            personId: item.id,
            personPhone: item.MobilePhone,
          }}
        />
      </AdaptoActions>
    </li>
  );
};

const itemStyle = css({
  background: theme.colors.white,
  borderRadius: theme.borderRadius.small,
  padding: theme.spacing(0.5, 1),
  marginBottom: theme.spacing(1),
  display: 'flex',
  alignItems: 'center',
  '> div:first-of-type': {
    display: 'flex',
    gap: theme.spacing(1),
    alignItems: 'center',
    width: '60%',
  },
  '> div:last-of-type': {
    flexGrow: 1,
    display: 'flex',
    justifyContent: 'flex-end',
  },
});
